<template>
  <normal-dialog
    :title="type ? '编辑设备' : '新增设备'"
    :visible="visible"
    :before-close="resetDialog"
    @update:visible="updateVisibleHandle"
  >
    <el-form
      :disabled="loading"
      label-width="150px"
    >

      <el-form-item label="校区">
        <area-select
          :disabled="type ? true : false"
          v-model="selected.campusId"
          @input="changeCampus"
          clearable
        />
      </el-form-item>

      <el-form-item label="运营商">

        <operator-select
          :disabled="true"
          clearable
          v-model="selected.operatorId"
          @input="changeOperator"
        />
      </el-form-item>

      <el-form-item label="设备编号">
        <el-input
          :disabled="type ? true : false"
          v-model.trim="selected.code"
          :maxlength="8"
          placeholder="请输入设备编号"
        ></el-input>
      </el-form-item>
      <el-form-item label="设备类型">
        <el-select
          :disabled="type ? true : false"
          v-model="selected.deviceType"
          @input="changeDeviceType"
          clearable
          placeholder="请选择设备类型"
        >
          <el-option
            v-for="item in deviceTypeOption"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>

      </el-form-item>

      <el-form-item label="运营模式">
        <el-radio-group v-model="selected.operationMode">
          <el-radio
            v-for="(item, index) in operationModeOptions"
            :key="index"
            :label="item.value"
          >{{ item.label }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="配置费率">
        <el-select
          v-model="selected.rateId"
          filterable
          clearable
          placeholder="请选择配置费率"
        >
          <el-option
            v-for="item in rateOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="设备位置"
        v-if="!this.type"
      >

        <el-select
          v-model="selected.positionId"
          @change="changePosition"
          filterable
          clearable
          placeholder="请选择设备位置"
        >
          <el-option
            v-for="(item,index) in positionList"
            :key="index"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>

      </el-form-item>
      <el-form-item
        label="设备位置"
        v-if="this.type"
      >
        <!-- :disabled="type ? false : true" -->
        <div class="bt_style ">

          <el-select
            class="select_style"
            v-if="this.changeBt"
            v-model="selected.positionId"
            @change="changePosition"
            filterable
            clearable
            placeholder="请选择设备位置"
          >
            <el-option
              v-for="(item,index) in positionList"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-input
            v-else
            v-model="selected.position"
          ></el-input>

          <el-button
            v-if="!this.changeBt"
            @click="updateEditPostion"
          >保存</el-button>
          <el-button
            v-if="this.changeBt &&this.type"
            @click="showEditPostion"
          >修改</el-button>
          <el-button
            v-if="!this.changeBt"
            @click="showEditPostion"
          >取消</el-button>
        </div>
      </el-form-item>
      <el-form-item
        label="用户数"
        v-if="selected.deviceType === 2"
      >
        <el-select
          v-model="selected.userAmount"
          filterable
          clearable
          placeholder="请选择同时允许登录用户数"
        >
          <el-option
            v-for="item in 3"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="用户1对应水路"
        v-if="selected.userAmount === 2"
      >
        <el-checkbox-group v-model="selected.user1WayConfig">
          <el-checkbox :label="1">第一路</el-checkbox>
          <el-checkbox :label="2">第二路</el-checkbox>
          <el-checkbox :label="3">第三路</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item
        label="用户2对应水路"
        v-if="selected.userAmount === 2"
      >
        <el-checkbox-group v-model="selected.user2WayConfig">
          <el-checkbox :label="1">第一路</el-checkbox>
          <el-checkbox :label="2">第二路</el-checkbox>
          <el-checkbox :label="3">第三路</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <template v-if="selected.deviceType == 2">
      <el-table
        border
        :data="selectRateOptions"
        style="width: 100%"
      >
        <el-table-column
          prop="coldMoney"
          label="一路费率价格（元）"
          :formatter="formatMoney"
          min-width="50"
        >
        </el-table-column>
        <el-table-column
          prop="coldMeasure"
          :label="`费率单位（ML）`"
          min-width="50"
        >
        </el-table-column>
      </el-table>
      <el-table
        border
        :data="selectRateOptions"
        style="width: 100%"
      >
        <el-table-column
          prop="hotMoney"
          label="二路费率价格（元）"
          :formatter="formatMoney"
          min-width="50"
        >
        </el-table-column>
        <el-table-column
          prop="hotMeasure"
          :label="`费率单位（ML）`"
          min-width="50"
        >
        </el-table-column>
      </el-table>
      <el-table
        border
        :data="selectRateOptions"
        style="width: 100%"
      >
        <el-table-column
          prop="warmMoney"
          label="三路费率价格（元）"
          :formatter="formatMoney"
          min-width="50"
        >
        </el-table-column>
        <el-table-column
          prop="warmMeasure"
          :label="`费率单位（ML）`"
          min-width="50"
        >
        </el-table-column>
      </el-table>
    </template>
    <template v-else>
      <el-table
        border
        :data="selectRateOptions"
        style="width: 100%"
      >
        <el-table-column
          prop="coldMoney"
          label="冷水费率价格（元）"
          :formatter="formatMoney"
          min-width="50"
        >
        </el-table-column>
        <el-table-column
          prop="coldMeasure"
          :label="`冷水费率单位（${selectRateOptions[0] && selectRateOptions[0].mode == 1 ? 'ML' : 'S'}）`"
          min-width="50"
        >
        </el-table-column>
      </el-table>
      <el-table
        border
        :data="selectRateOptions"
        style="width: 100%"
      >
        <el-table-column
          prop="hotMoney"
          label="热水费率价格（元）"
          :formatter="formatMoney"
          min-width="50"
        >
        </el-table-column>
        <el-table-column
          prop="hotMeasure"
          :label="`热水费率单位（${selectRateOptions[0] && selectRateOptions[0].mode == 1 ? 'ML' : 'S'}）`"
          min-width="50"
        >
        </el-table-column>
      </el-table>
    </template>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="resetDialog">取 消</el-button>
      <el-button
        type="primary"
        @click="submitUpdateHandle"
      >确 定</el-button>
    </div>
  </normal-dialog>
</template>
<script>
const dialogMixin = manageShell.default.mixinModule.Dialog;
import { mapGetters, mapActions } from 'vuex';
import { updateAdress } from '../../../../api/dispenser/location.js';
export default {
  props: {
    selectRateOptions: { type: Array },
    rateOptions: { type: Array },
    deviceTypeOption: { type: Array },
    positionList: { type: Array },
    operationModeOptions: { type: Array },
    changePosition: { type: Function },
    changeCampus: { type: Function },
    changeOperator: { type: Function },
    changeDeviceType: { type: Function },
  },
  data() {
    return {
      changeBt: true,
    };
  },
  mixins: [dialogMixin],
  methods: {
    ...mapActions('waterDispenser/equipment', [
      'fetchEquipmentList',
      'getPositionsList',
    ]),
    formatMoney(col, row, val) {
      return (val / 100).toFixed(2);
    },
    showEditPostion() {
      this.changeBt = !this.changeBt;
    },
    updateEditPostion() {
      updateAdress({
        id: this.selected.positionId,
        name: this.selected.position,
        campusId: this.selected.campusId,
      }).then(res => {
        this.fetchEquipmentList();
        this.getPositionsList({
          entity: { campusId: this.selected.campusId },
          data: this.selected.positionId
            ? {
                name: this.selected.position,
                id: this.selected.positionId,
              }
            : null,
        });
        this.changeBt = true;
      });
    },
  },
};
</script>
<style lang="scss">
@import '../../../../assets/styles/variables.scss';
.bt_style {
  display: flex;
  align-items: center;
  height: 40px;
}
.select_style {
  flex: 1;
}
</style>

